module.exports = __webpack_public_path__ + "img/blt-arrow08.57a5c248.svg";